import React, { Component } from 'react';
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { ComponentHeader, InformationModal, VerifiedModal } from '../common';
import { getAllSsoApi } from './Api';
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { Button, Col, Image, Row } from "react-bootstrap";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import editPencil from "../../assets/images/edit-icon.png";
import { SSO_VERIFY } from '../../utils/urls';
import FilterVefiedDropDown from '../common/FilterVefiedDropDown';
import { deleteAuthCommonApi } from "../content/Api";
import { toast } from 'react-toastify';
import { withRouter } from '../../utils/hoc/withRouter';
import { Tag } from 'antd';
import OptionsDropdown from '../../utils/commonComponent/OptionsDropdown';


class SsoPartners extends Component {
    constructor(props) {
        super(props);
        const AccesData = isModuleExist(MODULE_ID_MAP.PartnersPartners);

        this.state = {
            access: AccesData,
            delete: false,
            deleteData: {},
            editData: "",
            showEdit: false,
            isVerify: false,
            show: false,
            verified: '',
            verifyUrl: ''
        }
    }

    componentDidMount() {
        const { history } = this.props;
        // Preserve existing query params (page, search, filters) instead of wiping them
        const params = new URLSearchParams(this.props.location.search);
        if (!params.get("page")) {
            params.set("page", START_PAGE);
        }
        history({
            pathname: this.props.location.pathname,
            search: `?${params.toString()}`,
        }, { replace: true });
        this.props.getAllSsoApi(this);
    }
    componentDidUpdate(prevProps, prevState) {
        const prevParams = new URLSearchParams(prevProps.location.search);
        const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
        const prevVerified = prevParams.get("isVerified") || "";
        const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;

        const params = new URLSearchParams(this.props.location.search);
        const page = parseInt(params.get("page"), 10) || START_PAGE;
        const verified = params.get("isVerified") || "";
        const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;

        // const search = params.get("search") || "";

        if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
            this.setState({ currentPage: page }, () => {
                this.props.getAllSsoApi(this);

            });
        }
    }
    getDetailsSso = (data) => {
        this.props.history({ pathname: `/partner/${data?.uuid}`, state: { "data": data } });
    }
    getSsoUsers = (data) => {
        this.props.history({ pathname: `/partner/view-users/${data?.id}`, state: { "ssoPartnerId": data?.id } });
    }
    showEditModal = (rowData = null) => {
        this.props.history({ pathname: `/partners/edit/${rowData?.uuid}`, state: { "data": rowData } })
        this.setState({
            showEdit: !this.state.showEdit,
            editData: rowData
        });
    };
    openCloseDeleteModal = (rowData) => {
        this.setState({
            delete: !this.state.delete,
            deleteData: rowData,
        });
    };
    deleteHandle = async (id) => {
        const res = await deleteAuthCommonApi(`/sso/${id}`);
        // console.log(res)
        if (res?.status === 200) {
            this.props.getAllSsoApi(this);
            this.setState({
                delete: !this.state.delete
            });

        } else {
            toast.error("Somthis wrong...")
        }
    }

    editRole = (data) => {
        let state={}
        let path = `/edit-role/${data?.id}`

            state = { "uuid": data?.uuid }
        this.props.history({ pathname: path, state: state });
    }
    render() {
        const { access } = this.state;
        const { ssoList, totalPages, currentPage } = this.props.ssoState;
        // console.log('roleList', roleList);
        return (
            <>

                {this.state.delete && (
                    <InformationModal
                        show={this.state.delete}
                        id={this.state.deleteData?.uuid}
                        title={`Are you sure you want to delete ${this.state.deleteData?.companyName} ?`}
                        handleClose={this.openCloseDeleteModal}
                        handleDelete={this.deleteHandle}
                    />
                )}
                <VerifiedModal
                    // name={`this '${this.state.editData?.campaignName}' campaign.`}
                    name={`'${this.state.editData?.companyName}'`}
                    show={this.state.show}
                    url={SSO_VERIFY + `/${this.state?.editData?.uuid}`}
                    isVerified={this.state.isVerify}
                    handleCancel={() => { this.setState({ show: false }) }}
                    successRes={() => { this.props.getAllSsoApi(this) }}
                />
                <section className="request-section">
                    <ComponentHeader
                        title="Partners"
                        breadcrumb={[["Partners", "/partners"]]}
                        primaryBtn={access.createAccess ? "Add Partner" : ""}
                        handlePrimaryBtn={() => {
                            this.props.history({ pathname: "/partners/add", state: { ssoList } });
                        }}
                        ctx={this}
                    />
                    <Row>
                        <Col sm={2}>
                            <FilterVefiedDropDown ctx={this} />
                        </Col>
                    </Row>
                    <div className="commom-table-wrapper">
                        <CustomTable
                        ctx={this}
                            data={ssoList?.list || []}
                            columns={[
                                {
                                    width: 180,
                                    title: "Company Name",
                                    dataIndex: "companyName",
                                    className: "name",
                                    render:(text, rowData, dataKey) => {
                                            return rowData?.companyName;
                                    },
                                },
                                {
                                    width: access.verificationAccess ? 110 : 0,
                                    title: "Verified",
                                    dataIndex: "isVerified",
                                    className: "verify",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                                    },
                                },
                                {
                                    width: 110 ,
                                    title: "Partner",
                                    dataIndex: "partnerType",
                                    className: "verify",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                            return <div className=" d-flex align-items-center inter-medium">
                                                {rowData?.type || 'Na'}
                                            </div>;
                                    },
                                },
                                  {
                                    width: 80 ,
                                    title: "Type",
                                    dataIndex: "ssoType",
                                    className: "verify",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                            return <div className=" d-flex align-items-center inter-medium">
                                                {rowData?.ssoPartnerType?.type || 'Na'}
                                            </div>;
                                    },
                                },
                                {
                                    width: 80 ,
                                    title: "User Count",
                                    dataIndex: "usersCount",
                                    className: "verify",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                            return <div className=" d-flex align-items-center inter-medium">
                                                {rowData?.usersCount || 'Na'}
                                            </div>;
                                    },
                                },
                                {
                                    width: 150,
                                    title: "Company Logo",
                                    dataIndex: "companyLogo",
                                    className: "logo",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                            return <Image className="table-img" src={rowData?.companyLogo} alt="Company Logo" />;

                                    },
                                },

                                {
                                    width: 130,
                                    title: "Contact",
                                    dataIndex: "mobileNumber",
                                    className: "contact",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                            return rowData?.mobileNumber || 'Na';
                                    },
                                },
                                {
                                    width: 200,
                                    title: "Email",
                                    dataIndex: "emailAddress",
                                    className: "email",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                            return rowData?.emailAddress || 'Na';
                                    },
                                },
                                {
                                    width:20,
                                    title: "Action",
                                    dataIndex: "",
                                    fixed: "right",
                                    className: "",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                            return (


                                                <>
                                                    {/* <Button onClick={() => this.editRole(rowData)} className=" primary-btn mr-4">
                                                        {"Edit Role" }
                                                    </Button>
                                                    <Button onClick={() => this.getDetailsSso(rowData)} className=" primary-btn mr-4">
                                                        View Detail
                                                    </Button>
                                                    <Button onClick={() => this.getSsoUsers(rowData)} className=" primary-btn mr-4">
                                                        View Users
                                                    </Button>
                                                    {access.updateAccess && (
                                                        <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />
                                                    )}
                                                    {access.deleteAccess && (
                                                        <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                                                    )} */}
                                                    <OptionsDropdown
                                                        editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                                                        deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                                                        viewHandler={() => this.getDetailsSso(rowData)}
                                                        extra={
                                                            <>
                                                             <Button onClick={() => this.editRole(rowData)} className=" primary-btn py-2 f-s-14">
                                                        {"Edit Role" }
                                                    </Button>
                                                             <Button onClick={() => this.getSsoUsers(rowData)} className=" primary-btn py-2 f-s-14">
                                                        View Users
                                                    </Button>
                                                            </>
                                                        }
                                                    />
                                                </>

                                            );
                                    },
                                },
                            ]}
                           
                            total={ssoList?.length || 0}
              loading={this.state.isLoading}
                        />
                    </div>
                </section>
            </>
        )
    }
}

const mapStateToProps = state => ({
    ssoState: state.SsoState
});
const mapDispatchToProps = {
    getAllSsoApi,
}
SsoPartners.propTypes = {
    // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SsoPartners));